import { Directive, HostListener, Input, forwardRef, ElementRef } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'
import { EntityReference } from '../dto'

@Directive({
  selector: '[jmlLibReferenceRepr]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ReferenceReprDirective),
      multi: true
    }
  ]
})
export class ReferenceReprDirective implements ControlValueAccessor {
  @Input('jmlLibReferenceRepr') property: string
  private onChange: (value: any) => void
  private onTouched: () => void
  private entityReference: EntityReference | undefined

  constructor(private elementRef: ElementRef) {}

  @HostListener('blur')
  onTouchedCallback() {
    if (this.onTouched) {
      this.onTouched()
    }
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    if (this.onChange && this.entityReference) {
      this.entityReference[this.property] = value
      this.onChange(this.entityReference)
    }
  }

  writeValue(entityReference: EntityReference | undefined): void {
    this.entityReference = entityReference
    if (entityReference && this.property) {
      this.elementRef.nativeElement.value = entityReference[this.property] || ''
    } else {
      this.elementRef.nativeElement.value = ''
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn
  }

  setDisabledState?(isDisabled: boolean): void {
    this.elementRef.nativeElement.disabled = isDisabled
  }
}
